// extracted by mini-css-extract-plugin
export var actions = "_3j-0";
export var actionsContainer = "_3j-5";
export var border = "_3j-1";
export var childFullHeight = "_3j-c";
export var collapse = "_3j-2";
export var content = "_3j-7";
export var contentChild = "_3j-b";
export var fullscreen = "_3j-9";
export var headerContainer = "_3j-3";
export var hidePadding = "_3j-8";
export var noScrollX = "_3j-d";
export var noScrollY = "_3j-e";
export var optOutTopPadding = "_3j-a";
export var pagePadding = "_3j-6";
export var profile = "_3j-f";
export var profileContainer = "_3j-g";
export var profileImage = "_3j-h";
export var profileMain = "_3j-i";
export var profileSubtitle = "_3j-k";
export var profileTitle = "_3j-j";
export var tabsWrapper = "_3j-4";
export var title = "_3j-l";